import React from "react";
import Tablecomponent from "../../helpers/TableComponent/TableComp"
import Modalcomp from "../../helpers/ModalComp/Modalcomp";
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import { NavLink } from "react-router-dom";
import "./MediaUploadsTable.css"
import crowngold from "../../Images/crown-golden.png";
import dateFormat from 'dateformat';
import Greenwalk from '../../Images/greenwalk.png'
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone'
import MediaUploadsModal from './MediaUploadsModal'
import UploadMedia from './UploadMedia'
import Ordericon from '../../Images/order.svg'
import ViewMedia from './ViewMedia'
const current_date=(dateFormat(new Date(),"dd-mmm-yy"))

class DashboardTable extends React.Component{

    state={
        openview:false
    }

    createData=(parameter) =>{
        var keys=Object.keys(parameter)
        var values=Object.values(parameter)
  
        var returnobj={}
        
        for(var i=0;i<keys.length;i++){
        returnobj[keys[i]]=values[i]
        }
        return(returnobj)
        }

        modelopen=(data)=>{
            if(data==="view"){
                this.setState({openview:true})
            }
            else if(data==="edit"){
                this.setState({editopen:true})
            }
        }

        closemodal=()=>{
                this.setState({openview:false,editopen:false})
        }


    render(){
         
        return(
            <div>
                
               
     
             
                <Tablecomponent
                
                 heading={[
                    { id: "order", label: "Order" },
                    { id: "", label: "S.No" },
                    { id: "customer", label: "Member" },
                    { id: "gender", label: "Gender" },
                    { id: "age", label: "Age" },
                    { id: "date", label: "Date" },
                    { id: "time", label: "Time" },
                    { id: "", label: "Action" }
                ]}
  

            rowdata={[]}

    tableicon_align={"cell_eye"}
    modelopen={(e)=>this.modelopen(e)}
    
  />
 
        
        <Modalcomp clrchange="text_color" visible={this.state.openview} title={"View Media"} closemodal={(e)=>this.closemodal(e)}
        
        >
          <ViewMedia/>
          
        </Modalcomp>
      

        <Modalcomp  clrchange="text_color" visible={this.state.editopen} title={"Edit Media Uploads"} closemodal={(e)=>this.closemodal(e)}
        
        >
          
          < MediaUploadsModal/>
        </Modalcomp>
              

        </div>
        )
    }
}

export default DashboardTable;
